// @flow
import React from "react";
import Low from "../../../svg/facilities/is_low.svg";
import "./lowIcon.scss";

const LowIcon = () => <Low className="c-low-icon" />;

export default LowIcon;
